import { heroStats } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section id="top" className="relative w-full">
      <div className="relative w-full overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20cinematic%20dark%20crimson%20haze%20over%20a%20mysterious%20night%20city%20skyline%20with%20soft%20glowing%20lights%2C%20moody%20low%20key%20lighting%20and%20deep%20shadows%2C%20editorial%20atmosphere%2C%20large%20negative%20space%2C%20dramatic%20contrast%2C%20artistic%20photography&width=1600&height=900&seq=heila-hero-01&orientation=landscape"
          alt="黑料热点 当事人与圈内关系专题封面"
          className="absolute inset-0 h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/60 to-foreground-950/80" />

        <div className="relative z-10 mx-auto flex min-h-[560px] w-full max-w-5xl flex-col items-center justify-center px-4 py-16 text-center md:min-h-[640px] md:px-6 md:py-24">
          <span className="animate-fade-up rounded-full border border-background-50/25 bg-background-50/10 px-4 py-1.5 font-label text-xs tracking-widest text-background-100 backdrop-blur-sm">
            人物为线索 · 关系为路径
          </span>

          <h2 className="animate-fade-up mt-5 font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl">
            黑料热点 · 先弄清当事人是谁
          </h2>

          <p className="animate-fade-up mt-4 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
            把黑料热点里的当事人、主角、涉事方与关联人物集中整理，从圈内关系看线索，快速挖到人物背后的关系网。
          </p>

          <div className="animate-fade-up mt-7 flex w-full max-w-xl flex-col gap-2 sm:flex-row">
            <div className="flex flex-1 items-center gap-2 rounded-md border border-background-50/25 bg-background-50/10 px-3 py-2.5 backdrop-blur-sm">
              <i className="ri-search-line text-base text-background-200" />
              <input
                type="text"
                name="person_search"
                placeholder="搜索当事人 / 主角 / 关联人物"
                className="w-full bg-transparent text-sm text-background-50 placeholder:text-background-300 focus:outline-none"
              />
            </div>
            <button
              type="button"
              className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              搜索人物
            </button>
          </div>

          <div className="animate-fade-up mt-4 flex flex-wrap items-center justify-center gap-3">
            <a
              href="#collections"
              className="cursor-pointer whitespace-nowrap rounded-md bg-background-50 px-6 py-2.5 text-sm font-medium text-foreground-950 transition-colors hover:bg-background-200"
            >
              浏览合集索引
            </a>
            <a
              href="#people"
              className="cursor-pointer whitespace-nowrap rounded-md border border-background-50/30 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
            >
              查看当事人速览
            </a>
          </div>

          <div className="animate-fade-up mt-10 flex w-full flex-wrap items-center justify-center gap-x-10 gap-y-4 border-t border-background-50/15 pt-6">
            {heroStats.map((item) => (
              <div key={item.label} className="text-center">
                <div className="font-heading text-2xl font-bold text-background-50 md:text-3xl">{item.value}</div>
                <div className="mt-0.5 font-label text-xs tracking-wide text-background-300">{item.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}